export default theme => {
    return {
      mainLabel: {
        fontFamily: 'OktaNeueRegular',
        fontWeight: 500
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/generic/AdType.js